import SfLoadingSpinner from "components/Common/SfLoadingSpinner";
import { REQUIRED_FEATURE_FLAGS } from "helpers/sf_constants";
import useFeatureFlags from "hooks/useFeatureFlags";
import { AdminDashboardLazy } from "pages/lazyPages/sfLazyPages";

const AdminDashboardWrapper = () => {
    const [isFeatureFlagActive, areFeatureFlagsLoaded] = useFeatureFlags();
    if (!areFeatureFlagsLoaded) {
        return <SfLoadingSpinner />
    }

    const isRevampEnabled = !!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_USE_ADMIN_DASHBOARD_REVAMP);
    
    return <AdminDashboardLazy isRevampEnabled={isRevampEnabled} />;
};

export default AdminDashboardWrapper;
